const updateUpsellPrice = (count = 0) => {
  if(count >= 20) return;
  const priceWrapper = document.querySelector("div[data-essential-upsell-element='price']");
  if(!priceWrapper) {
    return setTimeout(() => {
      updateUpsellPrice(count + 1);
    }, 200);
  }

  const discountedPriceEl = priceWrapper.querySelector("div[data-essential-upsell-element='discounted-price']");
  const regularPriceEl = priceWrapper.querySelector("div[data-essential-upsell-element='regular-price']");

  [discountedPriceEl, regularPriceEl]
  .filter(Boolean)
  .forEach(priceEl => {
    const text = priceEl.textContent.trim();
    if (text.endsWith(".00")) {
      priceEl.textContent = text.slice(0, -3);
    }
  })
}

class PfStrengthBox extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        updateUpsellPrice();

        const variants = Array.from(this.querySelectorAll(".Selectbox"));
        if (!variants.length) return;

        const PVA = document.querySelector("pf-product-variants-and-atc");
        if (PVA && window.innerWidth < 768) return;

        const selectedVariant = this.querySelector(`.Selectbox[data-is-selected="true"][data-is-available="true"]`);
        const bestSaleVariant = this.querySelector(`.Selectbox[data-is-available="true"]:has(input[value="+2.0"])`);

        // Priority 1 — Explicitly preselected variant (metafield)
        if (this.clickVariant(selectedVariant)) return;

        // Priority 2 — Best sale variant (+2.0)
        if (this.clickVariant(bestSaleVariant)) return;

        // Priority 3 — First available variant
        const firstAvailable = variants.find(v => v.getAttribute("data-is-available") === "true");
        this.clickVariant(firstAvailable);
    }

    get productEl() {
      return document.querySelector("product-component");
    }

    clickVariant(variant) {
      if (!variant) return false;

      replaceStickyButtonListener();

      const label = variant.querySelector("label");
      if (label) {
          label.click();

          // const shouldReload = this.dataset.sellingPlans != 0 && !this.dataset.selectedVariant && this.productEl.dataset.noReload != "true" && this.dataset.productId == this.productEl.dataset.productId
          const shouldReload = this.dataset.sellingPlans != 0 && !this.dataset.selectedVariant && this.dataset.productId == this.productEl.dataset.productId

          if(shouldReload) {
            window.location.reload();
          } else {
            // this.productEl.dataset.noReload = "true";
          }

          return true;
      }
      return false;
    }
}

// Register custom element once
if (!customElements.get("pf-strength-box")) {
    customElements.define("pf-strength-box", PfStrengthBox);
}


/* -------------------------
   Scroll Listener Handling
------------------------- */

let scrollListenerAttached = false;

document.addEventListener("DOMContentLoaded", initScrollListener);
document.addEventListener("shopify:section:load", initScrollListener);

function initScrollListener() {
  if (scrollListenerAttached) return;

  const target = window;
  target.addEventListener('scroll', onScroll, { passive: true });
  target.addEventListener('touchmove', onScroll, { passive: true });

  scrollListenerAttached = true;
}

function onScroll() { 
  checkATCVisibility();
}


/* -------------------------
   Sticky ATC Visibility
------------------------- */

function checkATCVisibility() {
  const target = document.querySelector(".pm__atc-button");
  const target2 = document.querySelector("variant-selectbox");
  const stickyBar = document.querySelector(".pm__buttons-pay-quantity .pm__sticky-atc");
  if (!target || !target2 || !stickyBar) return;

  const rect = target.getBoundingClientRect();
  const rect2 = target2.getBoundingClientRect();
  // const isOutOfView = rect.top >= window.innerHeight || rect.bottom <= 0;
  const isOutOfView = rect.bottom <= 0 && rect2.bottom <= 0;

  if (isOutOfView) {
    stickyBar.classList.add("pf-sticky-open");
    stickyBar.classList.add("open");
    stickyBar.removeAttribute("aria-hidden");

    stickyBar.querySelectorAll("*").forEach(elm => elm.removeAttribute("aria-hidden"));

    replaceStickyButtonListener();
  } else {
    stickyBar.classList.remove("pf-sticky-open");
    stickyBar.classList.remove("open");
    stickyBar.setAttribute("aria-hidden", "true");
  }
}


/* -------------------------
   Sticky Button Listener
------------------------- */

function replaceStickyButtonListener() {
    const stickyBtn = document.querySelector(".pf-sticky-atc");
    const productBtn = document.querySelector(".pm__product-atc-wrapper button");
    if (!stickyBtn || !productBtn) return;

    const stickyButtonListener = () => {
        const PVA = document.querySelector("pf-product-variants-and-atc");
        const modal = PVA?.querySelector(".strength_modal_wrapper");
        const isVariant = PVA?.getAttribute('data-is-variant') === "false";

        if (PVA && window.innerWidth < 768 && isVariant){
          modal?.classList.add("active");
          window.scrollTo({
            top: 400,
            behavior: 'smooth'
          });
        } else{
          productBtn.click();
        }
    };

    stickyBtn.replaceWith(stickyBtn.cloneNode(true));
    const newStickyBtn = document.querySelector(".pf-sticky-atc");
    newStickyBtn.addEventListener("click", stickyButtonListener);
}

class PfProductV extends HTMLElement {
  constructor() {
    super();

    // Bind functions so "this" stays correct
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.outsideClickClose = this.outsideClickClose.bind(this);
  }

  connectedCallback() {
    this.chooseBtn = this.querySelector(".choose_strength_btn");
    this.modal = this.querySelector(".strength_modal_wrapper");
    this.closeBtn = this.querySelector(".close_btn");
    this.mainContent = this.querySelector(".main_content");
    this.atcBtn = this.querySelector(".atc_redirect_btn");
    const items = this.querySelectorAll(".pf_option");

    this.chooseBtn?.addEventListener("click", this.openModal);
    this.closeBtn?.addEventListener("click", this.closeModal);
    this.atcBtn?.addEventListener("click",() => {
        this.handleAtc();
    });


    // Close when clicking outside modal content
    this.modal?.addEventListener("click", this.outsideClickClose);

    items?.forEach((item)=>{
        item.addEventListener("click", (e)=>{
            this.itemClick(e, item);
        });
    })
  }

  get sellingPlans() {
    return parseInt(document.querySelector("pf-strength-box")?.dataset.sellingPlans || 0);
  }

  get tryonBtnExists() {
    return !!document.querySelector(".pm__product-atc-wrapper tryon-button");
  }

  openModal() {
    this.modal?.classList.add("active");
  }

  closeModal() {
    this.modal?.classList.remove("active");
  }

  outsideClickClose(event) {
    // If clicking outside `.main_content`, close modal
    if (!this.mainContent.contains(event.target)) {
      this.closeModal();
    }
  }

  itemClick(e,item){
    const value = item.getAttribute("data-value");
    const isAvailable = item.getAttribute("data-available");
    const strength = document.querySelector(`pf-strength-box .Selectbox:has(input[value="${value}"]) label`);
    this.setAttribute('data-is-variant', true);

    strength?.click();

    const isButton = e.target.closest(".option_atc_btn");
    if (isButton && (this.sellingPlans == 0 || !this.tryonBtnExists)) {
      setTimeout(() => {
        const productBtn = document.querySelector(".pm__product-atc-wrapper button");
        if (productBtn && document.body.contains(productBtn)) {
          productBtn.click();
        } else {
          console.warn("Button not connected to DOM yet");
        }
      }, 1000);
    }

    const atcButton = this.querySelector(".atc_redirect_btn");
    const chooseBtn = this.querySelector(".choose_strength_btn .text");
    chooseBtn.innerHTML = value;

    // atcButton.querySelectorAll("span").forEach(elm=>elm.innerHTML = atcButton.getAttribute("data-atc-text"));

    if(isAvailable === "false"){
      atcButton.querySelectorAll("span").forEach(elm=>elm.innerHTML = atcButton.getAttribute("data-ntf-text"));
    } else {
      atcButton.querySelectorAll("span").forEach(elm=>elm.innerHTML = atcButton.getAttribute("data-atc-text"));
    }

    this.closeModal();
  }

  handleAtc(){
    const isVariant = this.closest("pf-product-variants-and-atc").getAttribute('data-is-variant') === "true";
    const productBtn = document.querySelector(".pm__product-atc-wrapper button");

    if(isVariant){
        productBtn?.click();
    } else {
        this.openModal();
    }
  }
}

// Register custom element once
if (!customElements.get("pf-product-variants-and-atc")) {
  customElements.define("pf-product-variants-and-atc", PfProductV);
}

// Virtual Try-On Button
class PfVirtualTryonBtn extends HTMLElement {
  connectedCallback() {
    this.renderButton();
    
    let count = 0;
    let btnTimer = setInterval(() => {
      const existingButtonInDom = document.querySelector(".pf-virtual-tryon-btn");
      const maxCount = window.innerWidth <= 768 ? 15 : 10;

      if(!existingButtonInDom && count <= maxCount) {
        this.renderButton();
        count++;
      } else {
        let count = 0;
        clearInterval(btnTimer);
      }
    }, 1000);
  }

  disconnectedCallback() {}

  get customSlider() {
    return document.querySelector(".pmslider-own--slides-wrapper");
  }

  renderButton() {
    const existingButtonInDom = document.querySelector(".pf-virtual-tryon-btn");
    if(existingButtonInDom) existingButtonInDom?.remove();

    const buttonEl = `
      <button
        id="tryon-button"
        type="button"
        name="tryon"
        style="display: none;"
        class="pm__try-me-on__icon product-form__submit button button--full-width button--secondary pf-virtual-tryon-btn">
        ${this.dataset.icon}
        <span class="u-s4">${this.dataset.title}</span>
      </button>
    `;
    
    if(!this.customSlider) return console.log("Custom slider not loaded yet 🔴🔴🔴");

    this.customSlider.insertAdjacentHTML("beforeend", buttonEl);

    const buttonInDom = document.querySelector(".pf-virtual-tryon-btn");
    if(!buttonInDom) return console.log("Button wasn't inserted in DOM 🔴🔴🔴");

    buttonInDom.addEventListener("click", handleTryOnClick);

    this.updateCurrentVariantSku?.();
  }

  updateCurrentVariantSku() {
    const variantInput = document.querySelector('input[name="id"]');
    if (variantInput && typeof currentVariantSku !== 'undefined') {
      const newSku = variantInput.getAttribute('data-sku');
      currentVariantSku = (newSku && newSku.trim() !== '') ? newSku.trim() : null;
      
      window.skipProductValidation = true;
    }

    if (typeof tryonButton !== 'undefined') {
      tryonButton = document.getElementById('tryon-button');
    }

    if (typeof CheckSKU === 'function') {
      setTimeout(() => CheckSKU(), 100);
    }
  }
}

if(!customElements.get("pf-tryon-btn")) {
  customElements.define("pf-tryon-btn", PfVirtualTryonBtn);
}


// _pf_collection_strength_selector
class PfStrengthSelector extends HTMLElement {
  #controller = new AbortController();

  connectedCallback() {
    const { signal } = this.#controller;

    this.buttons.forEach(button => {
      button.addEventListener("click", this.onClick.bind(this), { signal });
    });

    this.syncWithUrl();

    window.addEventListener("popstate", () => this.syncWithUrl(), { signal });

    // listen for pushState / replaceState changes
    this.observeHistory();
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  get buttons() {
    return Array.from(this.querySelectorAll(".pf-strength-pill"));
  }

  get activeEl() {
    return this.querySelector(".pf-strength-pill[data-active='true']");
  }

  onClick(e) {
    e.preventDefault();

    const selectedValue = e.target?.dataset.value;
    if (!selectedValue) return console.warn("❌ selected value not found");

    const inputLabelEl = document.querySelector(`label[data-name="${selectedValue}"]`);
    if (!inputLabelEl) return console.warn("❌ inputLabelEl not found");

    this.setActive(selectedValue);

    inputLabelEl.click();
  }

  setActive(value) {
    this.activeEl?.setAttribute("data-active", false);

    const el = this.buttons.find(btn => btn.dataset.value === value);
    if (el) el.setAttribute("data-active", true);
  }

  clearActive() {
    this.activeEl?.setAttribute("data-active", false);
  }

  syncWithUrl() {
    const params = new URLSearchParams(window.location.search);
    const strength = params.get("filter.v.option.strength");

    if (!strength) {
      this.clearActive();
      return;
    }

    this.setActive(strength);
  }

  observeHistory() {
    if (window.__pfHistoryPatched) return;
    window.__pfHistoryPatched = true;

    const notify = () => window.dispatchEvent(new Event("urlchange"));

    ["pushState", "replaceState"].forEach(type => {
      const original = history[type];
      history[type] = function () {
        const result = original.apply(this, arguments);
        notify();
        return result;
      };
    });

    window.addEventListener("urlchange", () => this.syncWithUrl(), {
      signal: this.#controller.signal
    });
  }
}

if (!customElements.get("pf-strength-selector")) {
  customElements.define("pf-strength-selector", PfStrengthSelector);
}